import { useTranslation } from 'react-i18next';

import { Tabs, TabsList, TabsTrigger } from '@/components/ui/Tabs/Tabs';
import { APPROVAL_TAB_ORDER, ApprovalTab } from './approvalTabs';

/**
 * The status tabs of the coordinator's projects and suppliers lists (HAT-1105, 22/10/2026): the
 * office asked to see "the approved and the not-approved" side by side, "like in support requests".
 * What decides which tab an item is in lives in approvalTabs.ts.
 */
interface ApprovalStatusTabsProps {
  value: ApprovalTab;
  onChange: (tab: ApprovalTab) => void;
  counts: Record<ApprovalTab, number>;
}

const ApprovalStatusTabs = ({ value, onChange, counts }: ApprovalStatusTabsProps) => {
  const { t } = useTranslation();

  return (
    <Tabs value={value} onValueChange={(next) => onChange(next as ApprovalTab)} className="mb-6">
      <TabsList>
        {APPROVAL_TAB_ORDER.map((tab) => (
          <TabsTrigger key={tab} value={tab}>
            {t(`projects.tabs.${tab}`)} ({counts[tab]})
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
};

export default ApprovalStatusTabs;
